import { getAxios, TRPCPost } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { logger } from '@/infrastructure/logger';
import { IGetAllAppIDsReq, IGetAllAppIDsResp } from '@/proto/appid';
import { UpdateAppInfoReq, DeleteAppReq } from './index';

export const getAppConfigInfo = async (req: { appId: string }) => {
  try {
    const res = await getAxios().get(`/${API_PREFIX}/api/app/info`, {
      params: {
        appId: req.appId,
      },
    });
    return res.data?.data;
  } catch (e) {
    logger.error('getAppConfigInfo:', e);
    return {};
  }
};

export const getEpcBizList = async () => {
  try {
    const res = await getAxios().get(`/${API_PREFIX}/api/epc/bizs`);
    return res.data;
  } catch (e) {
    logger.error('getEpcBizList:', e);
    return [];
  }
};

export const getEpcSubBizList = async (param: { id: string }) => {
  try {
    const res = await getAxios().get(`/${API_PREFIX}/api/epc/subbizs`, {
      params: {
        bizId: param.id,
      },
    });
    return res.data;
  } catch (e) {
    logger.error('getEpcSubBizList:', e);
    return [];
  }
};

export const updateAppInfo = async (body: UpdateAppInfoReq) => {
  try {
    const res = await getAxios().post(`/${API_PREFIX}/api/app/update`, body);
    return res.data;
  } catch (e) {
    logger.error('updateAppInfo:', e);
    return null;
  }
};

export const deleteApp = async (body: DeleteAppReq): Promise<boolean> => {
  try {
    await getAxios().post(`/${API_PREFIX}/api/app/delete`, body);
    return true;
  } catch (e) {
    logger.error('updateAppInfo:', e);
    return false;
  }
};

export const getAllAppIDs = async (params: IGetAllAppIDsReq): Promise<IGetAllAppIDsResp> => {
  try {
    return await TRPCPost<IGetAllAppIDsResp>(
      `/${API_PREFIX}/trpc/trpc.appid_platform.appid_platform_service.AppidPlatformService/GetAllAppIDs`,
      params,
    );
  } catch (e) {
    logger.error('GetAllAppIDs e:', e);
    return {};
  }
};
